<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-upload</v-icon>
      File Upload:
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col sm="12" class="subtitle-1">Click the button below to upload your photos or videos!</v-col>
        <v-col sm="12" class="subtitle-1 text-center">
          <v-btn outlined @click="selectFile()">
            <v-icon left>fas fa-upload</v-icon>
            Upload File
          </v-btn>
          <input type="file" style="display: none" ref="fileInput" accept="video/*,image/*" @change="onFileSelected">
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    data(){
      return {
        selectedFile: null
      }
    },
    methods: {
      onFileSelected(file){
        this.selectedFile = file.target.files[0].name
        this.$store.dispatch('saveUploadedFile', file.target.files[0])
      },
      selectFile(){
        this.$refs.fileInput.click()
      }
    }
  }
</script>
